import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.hooks.useCreatePasskey', {
    errorText: 'Failed to add a passkey.',
    alreadyAddedError: 'This passkey is already added to your account',
});
